import React, { useState, useRef, useEffect } from 'react';
import { FALLBACK_AVATAR } from '../../utils/enums';

export interface UserOption {
    id: string;
    picture: string;
    name: string;
  }
interface DropdownProps {
  options: UserOption[];
  onSelect: (id: string) => void;
  initialOption: UserOption
}

function Dropdown({ options, onSelect, initialOption }: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<UserOption | null>(initialOption);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const initialOptionRef = useRef<UserOption | null>(initialOption || null);

  useEffect(() => {
    if (initialOptionRef.current && !selectedOption) {
      setSelectedOption(initialOptionRef.current);
    }
  }, []);

  const handleOptionClick = (option: UserOption) => {
    setSelectedOption(option);
    onSelect(option.id);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button className="dropdown-button" onClick={toggleDropdown}>
        {selectedOption ? selectedOption.name + " ▾" : 'Select Player ▾'}
      </button>
      {isOpen && (
        <ul className="dropdown-list">
          {options.map((option) => (
            <li
              key={option.id}
              className="dropdown-item"
              onClick={() => handleOptionClick(option)}
            >
              <img src={option.picture || FALLBACK_AVATAR} alt={option.name} className="user-avatar" />
              {option.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Dropdown;